import { ConciliacaoClient } from '@tradimus/api-conciliacao-client'

const basicAuthCredentials = process.env.VUE_APP_CONCILIACAO_BASIC_AUTH_USERNAME && process.env.VUE_APP_CONCILIACAO_BASIC_AUTH_PASSWORD
  ? { username: process.env.VUE_APP_CONCILIACAO_BASIC_AUTH_USERNAME, password: process.env.VUE_APP_CONCILIACAO_BASIC_AUTH_PASSWORD }
  : undefined

export const conciliacaoClient = new ConciliacaoClient({
  baseURL: `${process.env.VUE_APP_API_URL}/conciliacao`,
  basicAuthCredentials,
  withCredentials: false,
  getGrupoEconomicoId: () => {
    const grupoEconomicoId = sessionStorage.getItem('grupoEconomico')

    return grupoEconomicoId ? JSON.parse(grupoEconomicoId) : undefined
  },
  getAuthenticationToken: () => {
    const authenticationToken = sessionStorage.getItem('token')

    return authenticationToken
  }
})
